import { useAppSelector } from './redux';
import {
  formatClassificationText,
  mapClassificationToRiskLevel
} from '../utils/Functions.utils';

export const useDPIAData = () => {
  const { createDPIAResponse } = useAppSelector((state) => state.documentation);

  const footerData = {
    text: createDPIAResponse?.footerNote?.text ?? '',
    email: 'compliai@skyhighgrowth.com',
    reportId: '',
    generatedBy: createDPIAResponse?.footerNote?.generatedBy ?? ''
  };

  const headerData = {
    title: 'DPIA',
    entityType: {
      label: 'Entity Type',
      value: createDPIAResponse?.documentControl?.entityType ?? ''
    },
    systemName: {
      label: 'AI System Name',
      value: createDPIAResponse?.documentControl?.aiSystemName ?? ''
    },
    version: {
      label: 'Version',
      value: createDPIAResponse?.documentControl?.version ?? ''
    },
    organizationName: {
      label: 'Organization Name',
      value: createDPIAResponse?.documentControl?.organizationName ?? ''
    },
    provider: {
      label: 'Compliance Contact Person',
      value: createDPIAResponse?.documentControl?.complianceContactPerson ?? ''
    },
    classification: {
      risk: mapClassificationToRiskLevel(
        createDPIAResponse?.documentControl?.classification ?? ''
      ),
      text: formatClassificationText(
        createDPIAResponse?.documentControl?.classification ?? ''
      )
    },
    generatedTime: createDPIAResponse?.documentControl?.dateCreated ?? '',
    reportId: createDPIAResponse?.documentControl?.documentId ?? '',
    labels: {
      generatedLabel: 'Date Created',
      idLabel: 'Document ID'
    }
  };

  return { headerData, footerData };
};
